export type AdaptiveContentTargetObjectType = 'section' | 'variant' | 'page' | 'header-link';

export function getTextForTarget(target: AdaptiveContentTargetObjectType) {
    switch (target) {
        case 'header-link':
            return 'header item';
        default:
            return target;
    }
}
